<script lang="ts">
  import { onMount } from "svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import AvailabilityPolicyEditor from "@kontextwerk/control-web-frame/shared/modules/availability-policy-editor"
  import { validateAvailabilityPolicyConfig } from "@kontextwerk/control-web-frame/shared/logic/availability-policies"
  import type { AvailabilityPolicyConfig } from "@kontextwerk/control-web-client"

  type OverlayHostProps = {
    onremoveOverlay?: () => void
    onshowOverlay?: () => void
  }

  const {
    organizationId,
    value = null,
    disabled = false,
    onSave,
    onremoveOverlay = null,
    onshowOverlay = null,
  } = $props<
    {
      organizationId: string
      value?: AvailabilityPolicyConfig | null
      disabled?: boolean
      onSave: (value: AvailabilityPolicyConfig | null) => Promise<void> | void
    } & OverlayHostProps
  >()

  const initialDraft = () => value
  let draft = $state<AvailabilityPolicyConfig | null>(initialDraft())
  let saving = $state(false)
  let errorText = $state<string | null>(null)

  const close = () => {
    if (saving) return

    onremoveOverlay?.()
  }

  const save = async () => {
    if (saving || disabled) return

    const validationError = validateAvailabilityPolicyConfig(draft)

    if (validationError) {
      errorText = validationError

      return
    }

    saving = true
    errorText = null
    try {
      await onSave(draft)
      newNotification({ class: "success", html: "Servicezeiten gespeichert." })
      onremoveOverlay?.()
    } catch (err) {
      console.error("kehrblatt_service_hours_save_failed", err)
      errorText = "Servicezeiten konnten nicht gespeichert werden."
    } finally {
      saving = false
    }
  }

  onMount(() => {
    onshowOverlay?.()
  })
</script>

<div
  class="service-hours-editor-overlay"
  data-testid="kehrblatt.organizationSettings.serviceHoursOverlay"
>
  <AvailabilityPolicyEditor
    {organizationId}
    value={draft}
    disabled={saving || disabled}
    compact={true}
    label="Servicezeiten"
    helpModalTextId="organizationServiceHours"
    {errorText}
    onChange={(value) => {
      draft = value
      errorText = null
    }}
  />

  <div class="actions">
    <CTA type="primaryButton" content="Speichern" onClick={save} disabled={saving || disabled} />
  </div>
</div>

<style lang="less">
  .service-hours-editor-overlay {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 58rem;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    flex-wrap: wrap;
  }
</style>
